var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._b(
      { staticClass: "badge", class: [_vm.badgeVariant] },
      "div",
      _vm.$attrs,
      false
    ),
    [
      _vm.icon
        ? _c("img", {
            attrs: {
              src: "/media/inpulse-template-ac-new-a/profile/checked.svg",
              alt: "checked"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }